import { Capacitor } from '@capacitor/core';

export const mobileWidth = 744;

export function isMobile() {
  return Capacitor.isNativePlatform() || window.innerWidth <= mobileWidth;
}
